module.exports = __webpack_public_path__ + "static/media/ProgramSetup.4f9a7f8f.svg";